export default [
    {
        path: '/programmeDetails',
        name: 'programmeDetails',
        component: () => import("../views/programme/index.vue")
    },
    {
        path: '/information',
        name: 'information',
        component: () => import("../views/modelTemporary/information.vue")
    },
    {
        path: '/matchIntroduce',
        name: 'matchIntroduce',
        component: () => import("../views/modelTemporary/matchIntroduce.vue")
    },
    {
        path: '/AiZhilan',
        name: 'AiZhilan',
        component: () => import("../views/modelTemporary/AiZhilan.vue")
    },
    {
        path: '/radarInformation',
        name: 'radarInformation',
        component: () => import("../views/modelTemporary/radarInformation.vue")
    },
    {
        path: '/outOfThe',
        name: 'outOfThe',
        component: () => import("../views/modelTemporary/outOfThe.vue")
    }
]
